import React, { Component } from 'react';
import {
    ClipLoader,
    PuffLoader,
    ScaleLoader,
    SquareLoader,
    BeatLoader

} from "react-spinners";
import { css } from "@emotion/react";
import LottieAnimation from './Lottie/LottieAnimation';
import { classNames } from '../../common/css';

const override = css`
margin: auto;
`;

class AnimationClip extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let component = <ClipLoader
            loading={this.props.loading}
            color={this.props.color}
            size={this.props.size}
            speedMultiplier={this.props.speed || 1}
            css={override} />;

        switch (this.props.type) {
            case 'puff':
                component = <PuffLoader
                    loading={this.props.loading}
                    color={this.props.color}
                    size={this.props.size}
                    speedMultiplier={this.props.speed || 1}
                    css={override} />;
                break;
            case 'ScaleLoader':
                component = <ScaleLoader
                    loading={this.props.loading}
                    color={this.props.color}
                    size={this.props.size}
                    speedMultiplier={this.props.speed || 1}
                    css={override} />;
                break;
            case 'SquareLoader':
                component = <SquareLoader
                    loading={this.props.loading}
                    color={this.props.color}
                    size={this.props.size}
                    speedMultiplier={this.props.speed || 1}
                    css={override} />;
                break;
            case 'BeatLoader':
                component = <BeatLoader
                    loading={this.props.loading}
                    color={this.props.color}
                    size={this.props.size}
                    speedMultiplier={this.props.speed || 1}
                    css={override} />;
                break;
            case 'success':
                component = <LottieAnimation
                    height={this.props.height}
                    width={this.props.width}
                    name={'success'} />;
                break;
            default:
                break;
        }
        return (<div className={classNames('flex justify-center align-middle items-center', this.props.className)}>{component}</div>);
    }
}

export default AnimationClip;